import { Check, CloudOff, Loader2, Pencil } from "lucide-react";

const fmt = (d) => d?.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

export function AutosaveStatus({ status, savedAt }) {
  const map = {
    saving: [Loader2, "Saving…", "text-slate-500", "animate-spin"],
    saved: [Check, `All changes saved${savedAt ? ` · ${fmt(savedAt)}` : ""}`, "text-emerald-700", ""],
    unsaved: [Pencil, "Unsaved changes", "text-slate-500", ""],
    error: [CloudOff, "Couldn't autosave — retrying", "text-red-600", ""],
  };
  if (!map[status]) return null;
  const [Icon, label, color, spin] = map[status];
  return (
    <span className={`flex items-center gap-1.5 text-xs font-medium ${color}`} data-testid="autosave-status" data-status={status}>
      <Icon className={`h-3.5 w-3.5 ${spin}`} />{label}
    </span>
  );
}
